import { render, staticRenderFns } from "./smssign.vue?vue&type=template&id=5f36fb45&"
import script from "./smssign.vue?vue&type=script&lang=ts&"
export * from "./smssign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports